import React from 'react';

export function NotFound() {
  return (
    <h1>This page is not found.</h1>
  );
}
